import { getContext } from 'svelte';
import { MARKDOWN_SAFETY_CONTEXT } from '../../constants/contexts';

export type MarkdownSafety = {
	untrusted: boolean;
};

// How far the Markdown root trusts its source, for the link and image
// renderers. Absent outside a Markdown root, which means fully trusted.
export const getMarkdownSafetyContext = () =>
	getContext<MarkdownSafety | undefined>(MARKDOWN_SAFETY_CONTEXT);
